import {
  AlertTriangleIcon,
  CheckCircleIcon,
  InfoIcon,
  XCircleIcon,
} from "lucide-react";
import { type ReactElement, type ReactNode } from "react";
import { tw } from "~/utilities/styles";

type Props = {
  severity: keyof typeof severityStyles;
  title?: string;
  children?: ReactNode;
  actions?: ReactElement;
};

export function Alert({ severity, title, children, actions }: Props) {
  let Icon: typeof InfoIcon;
  switch (severity) {
    case "info":
      Icon = InfoIcon;
      break;
    case "success":
      Icon = CheckCircleIcon;
      break;
    case "warning":
      Icon = AlertTriangleIcon;
      break;
    case "error":
      Icon = XCircleIcon;
      break;
    default:
      Icon = InfoIcon;
  }

  return (
    <div
      className={`rounded-lg p-4 ${severityStyles[severity]} flex flex-row items-center gap-2`}
    >
      <div>
        <Icon className={`${iconStyles[severity]} size-4`} />
      </div>
      <div className="flex grow flex-col gap-1">
        {title && <span className="font-bold">{title}</span>}
        {children && <p className={title ? "text-muted" : ""}>{children}</p>}
      </div>
      {actions && <div className="flex shrink-0">{actions}</div>}
    </div>
  );
}

const severityStyles = {
  info: tw`bg-info/10`,
  success: tw`bg-success/10`,
  warning: tw`bg-warning/10`,
  error: tw`bg-error/10`,
};

const iconStyles: Record<keyof typeof severityStyles, string> = {
  info: tw`text-info`,
  success: tw`text-success`,
  warning: tw`text-warning`,
  error: tw`text-error`,
};
